import { FiveSymbolLocale } from '@site-builder/common/src/types/locale';

import { cartItemFactory } from '../../scripts/blocks/store/cart/cartItemFactory';
import { UniversalCart } from '../../scripts/blocks/store/cart/UniversalCart';
import { StoreAPIDataService } from '../../scripts/blocks/store/services/StoreAPIDataService';
import { showNotification } from '../../scripts/helpers/common';
import { transformFieldsFromStoreToCart } from '../store-helper';
import {
  getStoreMoreThan10GameKeysErrorText,
  getStoreNoGameKeysErrorText,
} from '../translation';
import { showLoaderCartButton } from './show-loader-cart-button';

export const addToCart =
  ({
    storeAPIDataService,
    locale,
    cart,
    sku,
  }: {
    storeAPIDataService: StoreAPIDataService;
    cart: UniversalCart;
    locale: FiveSymbolLocale;
    sku: string;
  }) =>
  async (drm?: string) => {
    let selectedDRM = drm;

    const loader = showLoaderCartButton(
      document.querySelectorAll(
        `[data-sku="${sku}"][data-button-type="add-to-cart"]`
      )
    );
    const foundData = storeAPIDataService.findBySku(sku);
    if (!foundData) {
      throw new Error(
        `The store item was not found in the received list when adding to the cart; SKU – ${sku}`
      );
    }
    loader(true);

    const unitItems = foundData?.unit_items;
    if (!selectedDRM && unitItems) {
      selectedDRM = unitItems[0].sku;
    }

    const price = selectedDRM
      ? unitItems.find((drm) => drm.sku === selectedDRM)?.price
      : foundData.price;
    const cartItem = cartItemFactory(
      transformFieldsFromStoreToCart({
        ...foundData,
        price,
        quantity: 1,
        selectedDRM,
      })
    );

    const res = await cart.add(cartItem);
    if (res && res.status === 'error') {
      if (res.error.id === 'gt10_gk') {
        showNotification(getStoreMoreThan10GameKeysErrorText(locale), 'error');
      }
      if (res.error.id === 'no_keys') {
        showNotification(getStoreNoGameKeysErrorText(locale), 'error');
      }
    }
    loader?.(false);
  };
